```html
<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="分类名称">
                <a-input
                  v-model="queryParam.categoryName"
                  placeholder="请输入"
                  allow-clear
                  @keyup.enter="handleQuery"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="类目层级">
                <a-select v-model="queryParam.grade" allow-clear placeholder="类目层级">
                  <a-select-option :value="1">一层</a-select-option>
                  <a-select-option :value="2">二层</a-select-option>
                  <a-select-option :value="3">三层</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择">
                  <a-select-option :value="1">正常</a-select-option>
                  <a-select-option :value="0">下线</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button
          type="primary"
          @click="
            () => {
              savedInnerPage = innerPagination.current
              $refs.createForm.handleAdd()
            }
          "
          v-hasPermi="['317c158a154a07c2e7835dfa5b4ea031c:0:c']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['317c158a154a07c2e7835dfa5b4ea031d:0:d']"
        ><a-icon type="edit" />修改</a-button
        >
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['317c158a154a07c2e7835dfa5b4ea031r:0:r']"
        ><a-icon type="delete" />删除</a-button
        >
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <goodscateDetail ref="goodscateDetail" @ok="getList" />
      <create-form
        ref="createForm"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="handleCreateFormOk"
        @level-change="setLevel"
      />
      <create-form
        ref="innerCreateForm"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="handleInnerFormOk"
        @level-change="setLevel"
      />
      <create-form
        ref="grandCreateForm"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="handleGrandFormOk"
        @level-change="setLevel"
      />
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :loading="loading"
        :size="tableSize"
        rowKey="categoryId"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        @expand="onExpand"
        :row-class-name="rowClassName"
        :custom-row="customRow"
      >
        <a-table
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          slot="expandedRowRender"
          slot-scope="record"
          :size="tableSize"
          rowKey="categoryId"
          :columns="innerColumns"
          :data-source="innerData"
          :pagination="isInnerPaginationVisible ? innerPagination : false"
          :loading="innerLoading"
          @expand="onInnerExpand"
          :row-class-name="rowClassName"
          :custom-row="customRow"
        >
          <a-table
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            slot="expandedRowRender"
            slot-scope="innerRecord"
            :size="tableSize"
            rowKey="categoryId"
            :columns="grandColumns"
            :data-source="grandData"
            :pagination="grandPagination"
            :loading="grandLoading"
            :row-class-name="rowClassName"
            :custom-row="customRow"
          >
            <span slot="status" slot-scope="text, rec">
              <a-tag v-if="rec.status == 1" color="green">正常</a-tag>
              <a-tag v-if="rec.status == 0" color="red">下线</a-tag>
            </span>
            <span slot="grade" slot-scope="text, rec">
              <a-tag v-if="rec.grade == 1" color="green">一层</a-tag>
              <a-tag v-if="rec.grade == 2" color="orange">二层</a-tag>
              <a-tag v-if="rec.grade == 3" color="red">三层</a-tag>
            </span>
            <div slot="pic" slot-scope="text, rec">
              <div v-viewer>
                <img
                  :src="$url + rec.pic"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <div slot="icon" slot-scope="text, rec">
              <div v-viewer>
                <img
                  :src="$url + rec.icon"
                  style="width: 60px; height: 60px; object-fit: contain"
                  @error="(e) => (e.target.src = errorImage)"
                />
              </div>
            </div>
            <span slot="operation" slot-scope="text, rec">
              <span :class="getOpCls(rec)">
                <a @click="$refs.grandCreateForm.handleUpdate(rec, undefined, 'grand')">修改</a>
                <a-divider type="vertical" />
                <a-dropdown>
                  <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a @click="$refs.goodscateDetail.init(rec, 1)">详情</a>
                    </a-menu-item>
                    <a-menu-item v-if="rec.grade != 3">
                      <a
                        @click="
                          () => {
                            savedGrandPage = grandPagination.current
                            $refs.createForm.handleAdd(rec)
                          }
                        "
                      >
                        新增
                      </a>
                    </a-menu-item>
                    <a-menu-item>
                      <a @click="handleDelete(rec, 'grand')">删除</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </span>
            </span>
          </a-table>
          <span slot="status" slot-scope="text, rec">
            <a-tag v-if="rec.status == 1" color="green">正常</a-tag>
            <a-tag v-if="rec.status == 0" color="red">下线</a-tag>
          </span>
          <span slot="grade" slot-scope="text, rec">
            <a-tag v-if="rec.grade == 1" color="green">一层</a-tag>
            <a-tag v-if="rec.grade == 2" color="orange">二层</a-tag>
            <a-tag v-if="rec.grade == 3" color="red">三层</a-tag>
          </span>
          <div slot="pic" slot-scope="text, rec">
            <div v-viewer>
              <img
                :src="$url + rec.pic"
                style="width: 60px; height: 60px; object-fit: contain"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </div>
          <div slot="icon" slot-scope="text, rec">
            <div v-viewer>
              <img
                :src="$url + rec.icon"
                style="width: 60px; height: 60px; object-fit: contain"
                @error="(e) => (e.target.src = errorImage)"
              />
            </div>
          </div>
          <span slot="operation" slot-scope="text, rec">
            <span :class="getOpCls(rec)">
              <a @click="$refs.innerCreateForm.handleUpdate(rec, undefined, 'inner')">修改</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="$refs.goodscateDetail.init(rec, 1)">详情</a>
                  </a-menu-item>
                  <a-menu-item v-if="rec.grade != 3">
                    <a
                      @click="
                        () => {
                          savedGrandPage = grandPagination.current
                          $refs.grandCreateForm.handleAdd(rec)
                        }
                      "
                    >
                      新增
                    </a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="handleDelete(rec, 'inner')">删除</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </span>
        </a-table>
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status == 1" color="green">正常</a-tag>
          <a-tag v-if="record.status == 0" color="red">下线</a-tag>
        </span>
        <span slot="grade" slot-scope="text, record">
          <a-tag v-if="record.grade == 1" color="green">一层</a-tag>
          <a-tag v-if="record.grade == 2" color="orange">二层</a-tag>
          <a-tag v-if="record.grade == 3" color="red">三层</a-tag>
        </span>
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              style="width: 60px; height: 60px; object-fit: contain"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <div slot="icon" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.icon"
              style="width: 60px; height: 60px; object-fit: contain"
              @error="(e) => (e.target.src = errorImage)"
            />
          </div>
        </div>
        <span slot="operation" slot-scope="text, record">
          <span :class="getOpCls(record)">
            <a @click="$refs.createForm.handleUpdate(record, undefined, 'parent')">修改</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多<a-icon type="double-right" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="$refs.goodscateDetail.init(record, 1)">详情</a>
                </a-menu-item>
                <a-menu-item v-if="record.grade != 3">
                  <a
                    @click="
                      () => {
                        savedInnerPage = innerPagination.current
                        $refs.innerCreateForm.handleAdd(record)
                      }
                    "
                  >
                    新增
                  </a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="handleDelete(record, 'parent')">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        position="bottom"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj } from '@/api/declaration/declarationClassification'
import CreateForm from './modules/CreateForm'
import goodscateDetail from './modules/goodscateDetail'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'GoodsCategory',
  components: { CreateForm, goodscateDetail },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  data() {
    return {
      isInnerPaginationVisible: true,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        categoryName: undefined,
        grade: 1,
        status: undefined,
      },
      single: false,
      multiple: true,
      columns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center', width: 170 },
        { title: '类目层级', dataIndex: 'grade', scopedSlots: { customRender: 'grade' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目展示图', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      errorImage: require('/src/assets/images/defaultImg.png'),
      innerData: [],
      innerLoading: false,
      innerColumns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center', width: 150 },
        { title: '类目层级', dataIndex: 'grade', scopedSlots: { customRender: 'grade' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目展示图', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      innerPagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total) => `共 ${total} 条`,
        onChange: (page, size) => this.handleInnerPageChange(page, size),
        onShowSizeChange: (page, size) => this.handleInnerPageChange(page, size),
      },
      currentParentId: null,
      grandData: [],
      grandLoading: false,
      grandColumns: [
        { title: '分类名称', dataIndex: 'categoryName', align: 'center', width: 150 },
        { title: '类目层级', dataIndex: 'grade', scopedSlots: { customRender: 'grade' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目展示图', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      grandPagination: {
        current: 1,
        pageSize: 5,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total) => `共 ${total} 条`,
        onChange: (page, size) => this.handleGrandPageChange(page, size),
        onShowSizeChange: (page, size) => this.handleGrandPageChange(page, size),
      },
      currentGrandParentId: null,
      currentLevel: 'parent',
      savedInnerPage: 1,
      savedGrandPage: 1,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    setLevel(level) {
      this.currentLevel = level
    },
    refreshParent() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    handleCreateFormOk() {
      this.refreshParent()
    },
    handleInnerFormOk() {
      this.innerPagination.current = this.savedInnerPage
      this.loadInnerData()
    },
    handleGrandFormOk() {
      this.grandPagination.current = this.savedGrandPage
      this.loadGrandData()
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        categoryName: undefined,
        grade: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.categoryId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row, level) {
      const ids = row.categoryId ? [{ categoryId: row.categoryId }] : this.ids.map((id) => ({ categoryId: id }))
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk: () => {
          return delObj(ids).then(() => {
            this.onSelectChange([], [])
            if (level === 'grand') {
              this.grandPagination.current = this.savedGrandPage
              this.loadGrandData()
            } else if (level === 'inner') {
              this.innerPagination.current = this.savedInnerPage
              this.loadInnerData()
            } else {
              this.refreshParent()
            }
            this.$message.success('删除成功', 3)
          })
        },
      })
    },
    onExpand(expanded, record) {
      if (!expanded) return
      this.currentParentId = record.categoryId
      this.innerPagination.current = 1
      this.loadInnerData()
    },
    loadInnerData() {
      const { current, pageSize } = this.innerPagination
      this.innerLoading = true
      fetchList({
        pageNum: current,
        pageSize,
        parentId: this.currentParentId,
      }).then((res) => {
        this.innerData = res.data.records
        this.innerPagination.total = res.data.total
        this.innerLoading = false
      })
    },
    handleInnerPageChange(page, size) {
      this.innerPagination.current = page
      this.innerPagination.pageSize = size
      this.loadInnerData()
    },
    onInnerExpand(expanded, record) {
      if (expanded) {
        this.isInnerPaginationVisible = false
        this.currentGrandParentId = record.categoryId
        this.grandPagination.current = 1
        this.grandPagination.pageSize = 5
        this.grandPagination.total = 0
        this.loadGrandData()
      } else {
        this.isInnerPaginationVisible = true
      }
    },
    loadGrandData() {
      const { current, pageSize } = this.grandPagination
      this.grandLoading = true
      fetchList({
        pageNum: current,
        pageSize,
        parentId: this.currentGrandParentId,
        grade: 3,
      }).then((res) => {
        this.grandData = res.data.records
        this.grandPagination.total = res.data.total
        this.grandLoading = false
      })
    },
    handleGrandPageChange(page, size) {
      this.grandPagination.current = page
      this.grandPagination.pageSize = size
      this.loadGrandData()
    },
    isSelected(record) {
      return this.selectedRowKeys.includes(record.categoryId)
    },
    getOpCls(record) {
      return this.isSelected(record) ? 'op-highlight' : ''
    },
    rowClassName(record) {
      return this.isSelected(record) ? 'row-selected' : ''
    },
    customRow(record) {
      return {
        on: {
          click: () => {
            const key = record.categoryId
            const keys = this.selectedRowKeys.slice()
            const idx = keys.indexOf(key)
            idx >= 0 ? keys.splice(idx, 1) : keys.push(key)
            this.onSelectChange(keys, this.list.filter(r => keys.includes(r.categoryId)))
          },
        },
      }
    },
  },
}
</script>

<style scoped>
.ant-table-thead > tr > th {
  background-color: #303133;
  color: #fff;
  font-weight: 600;
}
.ant-table-tbody > tr:nth-child(even) {
  background-color: #fafafa;
}
.ant-table-tbody > tr:nth-child(odd) {
  background-color: #ffffff;
}
.op-highlight {
  color: #1890ff;
  font-weight: bold;
}
.row-selected {
  background-color: #e6f7ff !important;
}
</style>
```
